var Component = require("!../../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../vue-loader/lib/selector?type=script&index=0!./TableFrame.vue"),
  /* template */
  require("!!../../../vue-loader/lib/template-compiler?id=data-v-59bbf304!../../../vue-loader/lib/selector?type=template&index=0!./TableFrame.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/vue2-datatable-component/src/Table/TableFrame.vue
// module id = 1217
// module chunks = 2